<template>
  <div class="inner_static">
    <h1 class="tit2">Style</h1>
    <section v-for="(style, index) in this.styleList" :key="index" class="sec_style">
      <div class="full-image">
        <img :src="getFullImage(style.styleFullImage)" @error="noImage" alt="ナチュラル">
      </div>
      <div class="class_wrap">
        <!--
          0.5 star : star5;
          1 star : star10;
          1.5 star : star15;
          2 star : star20;
          2.5 star : star25;
          3 star : star30;
          3.5 star : star35;
          4 star : star40;
          4.5 star : star45;
          5 star : star50;
        -->
        <dl class="lst_class">
          <dt>Class:</dt>
          <dd v-bind:class="{
                 star5: style.styleClass === 0.5,
                 star10: style.styleClass === 1,
                 star15: style.styleClass === 1.5,
                 star20: style.styleClass === 2,
                 star25: style.styleClass === 2.5,
                 star30: style.styleClass === 3,
                 star35: style.styleClass === 3.5,
                 star40: style.styleClass === 4,
                 star45: style.styleClass === 4.5,
                 star50: style.styleClass === 5
               }">
            <span class="tx">{{style.styleClass}}</span>
          </dd>
        </dl>
      </div>
      <ul class="lst_style_thumb">
        <li v-for="(thumbImage, index2) in style.styleThumbImages" :key="index2">
          <div class="thumb-image">
            <img :src="getThumbImage(thumbImage)" @error="noImage" alt="thumbImage">
          </div>
        </li>
      </ul>
      <h4 class="tit">{{style.styleName}}</h4>
      <p class="cnt">
        {{style.styleCaption}}
      </p>
      <dl class="lst_materials">
        <dt>Materials:</dt>
        <dd>
          <ul>
            <li v-for="(materialImage, index3) in style.styleMaterialImages" :key="index3">
              <div class="image">
                <img :src="materialImage" @error="noImage" alt="materialImage">
              </div>
            </li>
          </ul>
        </dd>
      </dl>
      <a class="btn_select" @click="btnSelectClick(style)"></a>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import {KG_URL} from '../../../constants/App'

export default {
  data () {
    return {
      styleList: []
    }
  },
  props: {
    selectedCategoryId: Number
  },
  methods: {
    init: function () {
      let payload = {
        params: {
          categoryId: this.selectedCategoryId
        }
      }
      axios.get(KG_URL.PLANNING + '/get-styles', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.styleList = response.data.data
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    getFullImage: function (styleFullImage) {
      return styleFullImage == null
        ? App.getKagullResource('noimage.svg')
        : App.getKagullResource('style/full/' + styleFullImage)
    },
    getThumbImage: function (thumbImage) {
      return thumbImage == null
        ? App.getKagullResource('noimage.svg')
        : App.getKagullResource('style/thumb/' + thumbImage)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    },
    btnSelectClick: function (style) {
      // 親コンポーネントのイベント実行
      this.$emit('selectStyleEvent', style)
    }
  },
  created () {
    this.init()
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/planning/StylePanel.vue